import { createGlobalStyle } from "styled-components";
import CircularEOT from "./fonts/lineto-circular-book.eot";
import CircularSVG from "./fonts/lineto-circular-book.svg";
import CircularTTF from "./fonts/lineto-circular-book.ttf";
import CircularWOFF from "./fonts/lineto-circular-book.woff";
import CircularMediumEOT from "./fonts/lineto-circular-medium.eot";
import CircularMediumSVG from "./fonts/lineto-circular-medium.svg";
import CircularMediumTTF from "./fonts/lineto-circular-medium.ttf";
import CircularMediumWOFF from "./fonts/lineto-circular-medium.woff";

export default createGlobalStyle`
  @font-face {
    font-family: 'Circular';
        src: url('${CircularEOT}');
        src: url('${CircularEOT}?#iefix') format('embedded-opentype'),
             url('${CircularWOFF}') format('woff'),
             url('${CircularTTF}') format('truetype'),
             url('${CircularSVG}#CircularSVG') format('svg');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Circular';
        src: url('${CircularMediumEOT}');
        src: url('${CircularMediumEOT}?#iefix') format('embedded-opentype'),
             url('${CircularMediumWOFF}') format('woff'),
             url('${CircularMediumTTF}') format('truetype'),
             url('${CircularMediumSVG}#CircularBoldSVG') format('svg');
    font-weight: 500;
    font-style: normal;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  html {
    font-size: 62.5%;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
  }

  body {
    font-family: ${({ theme }) => theme.styleGuide.fonts.sansSerif};
    font-size: 1.5rem;
    margin: 0;
    overflow-x: hidden;
    color: ${({ theme }) => theme.styleGuide.colors.gray[800]};
    background-color: ${({ theme, bg }) =>
      bg || theme.styleGuide.colors.gray[200]};
  }

  button {
    border: 0;
    background-color: transparent;
  }

  img,
  svg {
    vertical-align: middle;
    max-width: 100%;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }

  .js-focus-visible :focus:not(.focus-visible) {
    outline: none;
  }

  .intercom-lightweight-app {
    z-index: 2000 !important;
  }
`;
